module.exports = __webpack_public_path__ + "img/category_festivals__and__party.f4be231.png";